import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-funeral-parlour.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-funeral-parlour.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
let SearchFuneralParlourComponent = class SearchFuneralParlourComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    funeralParlourNameLabel = ApplicationSearchConstants.FORM_CONTROLS.contactNameLabel;
    funeralParlourSurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.contactSurnameLabel;
    funeralParlourOrganisationLabel = ApplicationSearchConstants.FORM_CONTROLS.organisationLabel;
    funeralParlourNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    funeralParlourSurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    funeralParlourOrganisationFormControl = ApplicationSearchConstants.FORM_CONTROLS.organisationFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    funeralParlourForm;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const parlourName = this.funeralParlourForm.get(this.funeralParlourNameFormControl).value;
        const parlourSurname = this.funeralParlourForm.get(this.funeralParlourSurnameFormControl).value;
        const parlourOrganisation = this.funeralParlourForm.get(this.funeralParlourOrganisationFormControl).value;
        this.applicationSearchCallback(this.applicationSearchService.searchByFuneralParlour(parlourName, parlourSurname, parlourOrganisation, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
    }
    setUpForm() {
        this.funeralParlourForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl(""),
            organisationFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
};
SearchFuneralParlourComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-funeral-parlour",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchFuneralParlourComponent);
export { SearchFuneralParlourComponent };
